import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { collection, getDoc, doc, setDoc, getDocs, writeBatch } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import { saveUserLog } from './LogandUtils'; // 경로에 맞게 수정
import styleClasses from './css/MyPage.module.scss';

function PushMember() {
  // URL 쿼리 파라미터: 예) ?memberId=ID1,ID2,ID3
  const [searchParams] = useSearchParams();
  const memberIdsParam = searchParams.get('memberId');
  const memberIds = memberIdsParam ? memberIdsParam.split(',') : [];
  
  const navigate = useNavigate();
  const user = auth.currentUser;
  
  const [musicards, setMusicards] = useState([]);
  const [selectedMusicard, setSelectedMusicard] = useState('');
  
  useEffect(() => {
    if (!user) {
      console.error("사용자가 로그인되어 있지 않습니다.");
      navigate('/login');
      return;
    }
    // 사용자의 musicard 필드 중 key에 "team"이 포함된 항목만 가져오기
    const fetchMusicards = async () => {
      try {
        const userDocSnap = await getDoc(doc(db, "users", user.uid));
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          const teamMusicardList = Object.entries(userData.musicard || {})
            .filter(([key]) => key.toLowerCase().includes("team"))
            .map(([key, value]) => ({
              id: key,
              name: value,
            }));
          setMusicards(teamMusicardList);
        } else {
          console.error("사용자 문서가 존재하지 않습니다.");
        }
      } catch (error) {
        console.error("뮤지카드 가져오기 오류:", error);
      }
    };
    fetchMusicards();
  }, [user, navigate]);
  
  const handleSubmit = async () => {
    if (!selectedMusicard || memberIds.length === 0) {
      alert("뮤지카드와 멤버를 선택해주세요.");
      return;
    }
  
    try {
      // 선택된 각 memberId에 대해 작업 수행
      for (const memberId of memberIds) {
        // 1. /users_data/[UID]/members/{memberId} 문서에서 멤버 데이터 가져오기
        const memberRef = doc(db, "users_data", user.uid, "members", memberId);
        const memberSnap = await getDoc(memberRef);
        if (!memberSnap.exists()) {
          alert(`복사할 멤버 데이터를 찾을 수 없습니다: ${memberId}`);
          continue;
        }
        const memberData = memberSnap.data();
  
        // 2. 가져온 멤버 데이터에 memberId와 ownerId를 추가하여 musicians 컬렉션에 저장
        // 대상 경로: musicians/[선택한뮤지카드]/members/[memberId]
        const musicianMemberRef = doc(db, "musicians", selectedMusicard, "members", memberId);
        await setDoc(musicianMemberRef, {
          ...memberData,
          memberId,
          ownerId: user.uid,
        }, { merge: true });

        await saveUserLog('musicard_logs', selectedMusicard, 'create', musicianMemberRef.path, 'PushMember');
  
        // 3. /users_data/[UID]/members/{memberId} 문서의 act 필드를 업데이트
        // act 필드에 해당 뮤지카드 ID와 memberId를 기록합니다.
        await setDoc(memberRef, {
          act: {
            [selectedMusicard]: memberId
          }
        }, { merge: true });
      }
  
      alert("뮤지카드에 선택한 멤버들이 추가되었습니다!");
      navigate("/my-page/members");
    } catch (error) {
      console.error("멤버 추가 오류:", error);
      alert("멤버 추가 중 오류가 발생했습니다.");
    }
  };
  
  return (
    <div className={styleClasses.pushPage}>
      <h1>뮤지카드로 멤버 내보내기</h1>
      <p>팀 뮤지션 유형 뮤지카드에만 내보낼 수 있습니다.</p>
      <div className={styleClasses.form}>
        <label>내 뮤지카드 선택</label>
        <select value={selectedMusicard} onChange={(e) => setSelectedMusicard(e.target.value)}>
          <option value="">뮤지카드를 선택하세요</option>
          {musicards.map((card) => (
            <option key={card.id} value={card.name}>
              {card.name}
            </option>
          ))}
        </select>
        <button onClick={handleSubmit} className="primaryButton">
          멤버 내보내기
        </button>
      </div>
    </div>
  );
}

export default PushMember;